import Server from '../server/server'

const updateTradeTable = async(id, collection, data) => {

    const result = await Server.updateTradeTable(id, collection, data)

    return result
}

export default updateTradeTable